module.exports = __webpack_public_path__ + "static/media/arrow-up-1.fcc734fc.svg";